"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Close = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var close_svg_1 = __importDefault(require("../../styles/Icons/assets/close.svg"));
function Close(_a) {
    var onClick = _a.onClick, csx = _a.csx, title = _a.title;
    return (theme_ui_1.jsx(__1.IconButton, { icon: close_svg_1.default, onClick: onClick, title: title, csx: csx }));
}
exports.Close = Close;
